
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import FeriadoService from "@/service/v1/sigap/FeriadoService";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";

@Options({
    name: "FeriadoIndex",
    components: { CardRh, KDataTable, Cadastro, Editar },
})
export default class FeriadoIndex extends IndexModelTable {
    public modal_turma;
    public data_min: any = null;
    public data_max: any = null;
    public ano: any = null; 

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() { 
        this.ano = null;
        this.data_min = null;
        this.data_max = null;
        this.refreshTable();
    }

    created() {
        this.service = new FeriadoService();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    ano: this.ano, 
                };
                return dados;
            }
        };

        this.modal_turma = "modal_npce_turma_";
        this.modal_atualizar = "modal_hora_aulas_update_";
        this.config.columns = [
            { data: "id", name: "id", class: "desktop" },
            { data: "data", name: "data" },
            { data: "tipo.nome", name: "tipo.nome" },
        ];
        this.config.columnDefs = [
            {
                targets: 1,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = "";
                        let buttom = "";
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-success btn-sm" btn-editar ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                            this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                        texto = texto + '<button class="btn btn-pmes-danger btn-sm" btn-excluir ' + buttom + '><i class="fa fa-trash"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }

    public tableatualizada() {
        $("[btn-editar]").click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
        $("[btn-excluir]").click((btn) => {
            const id = $(btn.currentTarget).data("id");
            this.excluirModelo(id);
        });
    }
}
